import { dispatchMiddleware } from "nemuru-components";
import React from "react";
import { setDictionaryValuesByParams } from "../config/flows/utils";
import {
  defaultLang,
  defaultRegistry,
  dictionaryList,
} from "../config/languages";
import { neutralTheme } from "../config/themes";

export const ConfigContext = React.createContext();
const initialState = {
  language: undefined,
  registry: defaultRegistry,
  dictionaryValues: dictionaryList[defaultLang][defaultRegistry].root,
  appTheme: neutralTheme,
  region: undefined,
  themeName: null,
  themed: false,
};
const actions = {
  SET_LANGUAGE: {
    changeState: (state, action) => {
      return {
        ...state,
        language: action.payload,
        dictionaryValues: dictionaryList[action.payload][state.registry].root,
      };
    },
  },
  SET_REGION: {
    changeState: (state, action) => {
      return {
        ...state,
        region: action.payload,
      };
    },
  },
  SET_REGISTRY: {
    changeState: (state, action) => {
      return {
        ...state,
        registry: action.payload.registry,
        dictionaryValues: setDictionaryValuesByParams(
          state.language,
          action.payload.registry,
          action.payload.fulfilledBy
        ),
      };
    },
  },
  UPDATE_CONFIG_CONTEXT: {
    changeState: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
  CHANGE_THEME: {
    changeState: (state, action) => {
      return {
        ...state,
        appTheme: action.payload,
        themeName: action.payload.themeName,
      };
    },
  },
};

function reducer(state, action) {
  return actions[action.type].changeState(state, action);
}

export default function ConfigContextProvider(props) {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const middlewareDispatch = dispatchMiddleware(dispatch, actions);
  const value = { state, dispatch: middlewareDispatch };

  return (
    <ConfigContext.Provider value={value}>
      {props.children}
    </ConfigContext.Provider>
  );
}
